import { useMutation, useQueryClient } from "react-query";
import { useAuthUserQuery } from "../../../user/hooks/queries/useAuthUserQuery";

import { markNotificationsAsRead } from "../../api/notifications";

import { NOTIFICATIONS_QUERY_KEY } from "../queries/useNotificationsQuery";

export const useMarkNotificationsAsReadMutation = () => {
  const { data: userData } = useAuthUserQuery();

  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation(markNotificationsAsRead, {
    onMutate: async ids => {
      await queryClient.cancelQueries(NOTIFICATIONS_QUERY_KEY);

      const oldNotifications = queryClient.getQueryData(
        NOTIFICATIONS_QUERY_KEY
      );

      // optimistic update
      queryClient.setQueryData(NOTIFICATIONS_QUERY_KEY, old =>
        old.map(notification => {
          if (ids.includes(notification.id)) {
            return {
              ...notification,
              readed: true,
              read_at: new Date().toISOString(),
              read_session: userData?.session_token
            };
          }

          return notification;
        })
      );

      return { oldNotifications };
    },

    onError: (err, ids, context) => {
      queryClient.setQueryData(
        NOTIFICATIONS_QUERY_KEY,
        context.oldNotifications
      );
    },

    onSettled: () => {
      queryClient.invalidateQueries(NOTIFICATIONS_QUERY_KEY);
    }
  });

  return {
    markAsRead: mutate,
    isLoading
  };
};
